module.exports = __webpack_public_path__ + "c28e33e7cbcda387f2816ad27442a1f9.svg";